import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import AntenneMap from './Antenne_Map';

function AntenneContact({ antenne }) {
    if (!antenne) {
        return (
            <div className="antenne-contact-error">
                <p>Les informations de l'antenne sont indisponibles.</p>
            </div>
        );
    }

    return (
        <div className="container my-5">
            <h2 className="section-title">{antenne.nom}</h2>
            <div className="row mb-4">
                <div className="col-md-6">
                    <div className="antenne-card">
                        <h3>Contacts</h3>
                        <div className="d-flex flex-column gap-3">
                            {antenne.contacts.map((contact, index) => {
                                const hasEmailAndPhone = contact.email && contact.telephone; // Si le contact a à la fois un email et un téléphone
                                return hasEmailAndPhone ? (
                                    <div key={index} className="d-flex justify-content-between gap-3 contact-group">
                                        <a
                                            href={`mailto:${contact.email}`}
                                            className="btn btn-primary contact-btn flex-fill"
                                        >
                                            <FontAwesomeIcon icon={faEnvelope} /> Email {contact.label}
                                        </a>
                                        <a
                                            href={`tel:${contact.telephone}`}
                                            className="btn btn-primary contact-btn flex-fill"
                                        >
                                            <FontAwesomeIcon icon={faPhoneAlt} /> Téléphone {contact.label}
                                        </a>
                                    </div>
                                ) : (
                                    <div key={index} className="d-flex justify-content-center">
                                        {contact.email && (
                                            <a
                                                href={`mailto:${contact.email}`}
                                                className="btn btn-primary contact-btn w-100"
                                            >
                                                <FontAwesomeIcon icon={faEnvelope} /> Email {contact.label}
                                            </a>
                                        )}
                                        {contact.telephone && (
                                            <a
                                                href={`tel:${contact.telephone}`}
                                                className="btn btn-primary contact-btn w-100"
                                            >
                                                <FontAwesomeIcon icon={faPhoneAlt} /> Téléphone {contact.label}
                                            </a>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <AntenneMap address={antenne.adresse} />
                </div>
            </div>
        </div>
    );
}

export default AntenneContact;
